module.exports = __webpack_public_path__ + "static/jamila-8c4fd4e9c7d5adfb7af67c199d13bb7c.png";